import { render, staticRenderFns } from "./race_manage.vue?vue&type=template&id=f35c8aae&scoped=true"
import script from "./race_manage.vue?vue&type=script&lang=js"
export * from "./race_manage.vue?vue&type=script&lang=js"
import style0 from "./race_manage.vue?vue&type=style&index=0&id=f35c8aae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35c8aae",
  null
  
)

export default component.exports